/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CenterUserDto } from '../models/center-user-dto';
import { ChildDto } from '../models/child-dto';
import { FindChildAuthResponseDto } from '../models/find-child-auth-response-dto';
import { LpInspectionCouponDto } from '../models/lp-inspection-coupon-dto';
import { LpInspectionDto } from '../models/lp-inspection-dto';
import { nonMemberControllerCheck } from '../fn/non-member/non-member-controller-check';
import { NonMemberControllerCheck$Params } from '../fn/non-member/non-member-controller-check';
import { nonMemberControllerCreate } from '../fn/non-member/non-member-controller-create';
import { NonMemberControllerCreate$Params } from '../fn/non-member/non-member-controller-create';
import { nonMemberControllerFindChildById } from '../fn/non-member/non-member-controller-find-child-by-id';
import { NonMemberControllerFindChildById$Params } from '../fn/non-member/non-member-controller-find-child-by-id';
import { nonMemberControllerFindTeacherByChildId } from '../fn/non-member/non-member-controller-find-teacher-by-child-id';
import { NonMemberControllerFindTeacherByChildId$Params } from '../fn/non-member/non-member-controller-find-teacher-by-child-id';
import { nonMemberControllerGetChildAuth } from '../fn/non-member/non-member-controller-get-child-auth';
import { NonMemberControllerGetChildAuth$Params } from '../fn/non-member/non-member-controller-get-child-auth';
import { nonMemberControllerHasLpInspection } from '../fn/non-member/non-member-controller-has-lp-inspection';
import { NonMemberControllerHasLpInspection$Params } from '../fn/non-member/non-member-controller-has-lp-inspection';
import { nonMemberControllerSearchCoupon } from '../fn/non-member/non-member-controller-search-coupon';
import { NonMemberControllerSearchCoupon$Params } from '../fn/non-member/non-member-controller-search-coupon';
import { nonMemberControllerSearchOffsetByUser } from '../fn/non-member/non-member-controller-search-offset-by-user';
import { NonMemberControllerSearchOffsetByUser$Params } from '../fn/non-member/non-member-controller-search-offset-by-user';
import { nonMemberControllerUse } from '../fn/non-member/non-member-controller-use';
import { NonMemberControllerUse$Params } from '../fn/non-member/non-member-controller-use';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class NonMemberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `nonMemberControllerFindTeacherByChildId()` */
  static readonly NonMemberControllerFindTeacherByChildIdPath = '/api/non-member/teacher';

  /**
   * 아동의 선생님 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerFindTeacherByChildId()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerFindTeacherByChildId$Response(params: NonMemberControllerFindTeacherByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserDto>>> {
    return nonMemberControllerFindTeacherByChildId(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동의 선생님 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerFindTeacherByChildId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerFindTeacherByChildId(params: NonMemberControllerFindTeacherByChildId$Params, context?: HttpContext): Observable<Array<CenterUserDto>> {
    return this.nonMemberControllerFindTeacherByChildId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterUserDto>>): Array<CenterUserDto> => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerHasLpInspection()` */
  static readonly NonMemberControllerHasLpInspectionPath = '/api/non-member/lp';

  /**
   * 아동의 적합성검사 결과 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerHasLpInspection()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerHasLpInspection$Response(params: NonMemberControllerHasLpInspection$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return nonMemberControllerHasLpInspection(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동의 적합성검사 결과 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerHasLpInspection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerHasLpInspection(params: NonMemberControllerHasLpInspection$Params, context?: HttpContext): Observable<boolean> {
    return this.nonMemberControllerHasLpInspection$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerSearchOffsetByUser()` */
  static readonly NonMemberControllerSearchOffsetByUserPath = '/api/non-member/search/offset/user';

  /**
   * LP검사 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerSearchOffsetByUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerSearchOffsetByUser$Response(params: NonMemberControllerSearchOffsetByUser$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>> {
    return nonMemberControllerSearchOffsetByUser(this.http, this.rootUrl, params, context);
  }

  /**
   * LP검사 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerSearchOffsetByUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerSearchOffsetByUser(params: NonMemberControllerSearchOffsetByUser$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}> {
    return this.nonMemberControllerSearchOffsetByUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LpInspectionDto>;
} => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerSearchCoupon()` */
  static readonly NonMemberControllerSearchCouponPath = '/api/non-member/search/offset/coupon';

  /**
   * 쿠폰 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerSearchCoupon()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerSearchCoupon$Response(params: NonMemberControllerSearchCoupon$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionCouponDto>;
}>> {
    return nonMemberControllerSearchCoupon(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerSearchCoupon$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerSearchCoupon(params: NonMemberControllerSearchCoupon$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LpInspectionCouponDto>;
}> {
    return this.nonMemberControllerSearchCoupon$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionCouponDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LpInspectionCouponDto>;
} => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerGetChildAuth()` */
  static readonly NonMemberControllerGetChildAuthPath = '/api/non-member/auth/child';

  /**
   * 아동 인증 페이지.
   *
   * 아동 인증을 위한 페이지입니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerGetChildAuth()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerGetChildAuth$Response(params?: NonMemberControllerGetChildAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildDto>> {
    return nonMemberControllerGetChildAuth(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동 인증 페이지.
   *
   * 아동 인증을 위한 페이지입니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerGetChildAuth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerGetChildAuth(params?: NonMemberControllerGetChildAuth$Params, context?: HttpContext): Observable<ChildDto> {
    return this.nonMemberControllerGetChildAuth$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChildDto>): ChildDto => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerFindChildById()` */
  static readonly NonMemberControllerFindChildByIdPath = '/api/non-member/auth/child';

  /**
   * 아동 인증.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerFindChildById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nonMemberControllerFindChildById$Response(params: NonMemberControllerFindChildById$Params, context?: HttpContext): Observable<StrictHttpResponse<FindChildAuthResponseDto>> {
    return nonMemberControllerFindChildById(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동 인증.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerFindChildById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nonMemberControllerFindChildById(params: NonMemberControllerFindChildById$Params, context?: HttpContext): Observable<FindChildAuthResponseDto> {
    return this.nonMemberControllerFindChildById$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindChildAuthResponseDto>): FindChildAuthResponseDto => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerCheck()` */
  static readonly NonMemberControllerCheckPath = '/api/non-member/check';

  /**
   * 쿠폰 사용 가능 여부 확인.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerCheck$Response(params: NonMemberControllerCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
    return nonMemberControllerCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 사용 가능 여부 확인.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nonMemberControllerCheck(params: NonMemberControllerCheck$Params, context?: HttpContext): Observable<LpInspectionCouponDto> {
    return this.nonMemberControllerCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionCouponDto>): LpInspectionCouponDto => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerCreate()` */
  static readonly NonMemberControllerCreatePath = '/api/non-member/inspection/start';

  /**
   * LP적합성 검사 생성.
   *
   * 검사를 시작합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nonMemberControllerCreate$Response(params: NonMemberControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return nonMemberControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * LP적합성 검사 생성.
   *
   * 검사를 시작합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nonMemberControllerCreate(params: NonMemberControllerCreate$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.nonMemberControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

  /** Path part for operation `nonMemberControllerUse()` */
  static readonly NonMemberControllerUsePath = '/api/non-member/coupon/use';

  /**
   * 쿠폰 사용.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nonMemberControllerUse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nonMemberControllerUse$Response(params: NonMemberControllerUse$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
    return nonMemberControllerUse(this.http, this.rootUrl, params, context);
  }

  /**
   * 쿠폰 사용.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nonMemberControllerUse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nonMemberControllerUse(params: NonMemberControllerUse$Params, context?: HttpContext): Observable<LpInspectionDto> {
    return this.nonMemberControllerUse$Response(params, context).pipe(
      map((r: StrictHttpResponse<LpInspectionDto>): LpInspectionDto => r.body)
    );
  }

}
